<template>
  <FullPageLayout>
    <div class="mx-auto mt-8 flex w-full max-w-[1100px]">
      <div class="hidden sm:block left-panel flex-shrink-0 w-[260px]">
        <CorporateMenu />
      </div>
      <nuxt-child key="kurumsal-child" class="mx-4 sm:ml-8 w-full child__container" />
    </div>
  </FullPageLayout>
</template>
<script>
import { defineComponent, useRoute, useMeta, useContext } from '@nuxtjs/composition-api';
import FullPageLayout from '@/modules/common/components/layout/FullPageLayout';
import { HOST_URL } from '@/constants/config';
import CorporateMenu from '~/modules/corporate/components/CorporateMenu';
import { useTracking } from '~/modules/tracking/composables/useTracking';
export default defineComponent({
  components: {
    CorporateMenu,
    FullPageLayout,
  },
  head: {},
  setup() {
    const route = useRoute();
    const { $cache } = useContext();
    $cache('public, max-age=60');
    // ------- Google Pageview Event Beginning -------
    const { sendPageviewEvent } = useTracking();
    sendPageviewEvent({
      page: {
        type: 'Statik',
      },
    });
    // ------- Google Pageview Event End -------
    useMeta(() => {
      const path = route.value.path;
      return { link: [{ hid: 'canonical', rel: 'canonical', href: HOST_URL + path }] };
    });

    return {};
  },
});
</script>
<style lang="scss">
a {
  &.nuxt-link-active {
    color: var(--text-anchor);
    background: #efefef;
  }
}
.child__container {
  h1 {
    font-weight: bold;
    font-size: 1.4rem;
    margin-bottom: 1rem;

    &:after {
      border-bottom: 1px solid var(--black-30);
      content: '';
      display: block;
      height: 1px;
      position: absolute;
      width: 170px;
    }
  }
  h2 {
    font-weight: bold;
    margin-bottom: 10px;
    font-size: 1.1rem;
    color: var(--black-60);
  }
  h3 {
    margin-bottom: 10px;
    font-size: 1rem;
    font-weight: bold;
    color: var(--black-60);
  }
  ul,
  ol {
    list-style: disc;
    margin-left: 2rem;
    li {
      margin-bottom: 15px;
    }
  }

  > p {
    margin-top: 15px;
    margin-bottom: 15px;
    &.italic {
      font-style: italic;
    }
    &.terms {
      line-height: 23px;
      padding-bottom: 20px;
    }
  }
  a {
    color: var(--text-anchor);
    &:hover {
      color: var(--hover-text-anchor);
    }
  }
}
</style>
